// extracted by mini-css-extract-plugin
export default {"searchBarLabel":"SearchBar_searchBarLabel__ZZl9D","searchBar":"SearchBar_searchBar__8hPdN","searchBtn":"SearchBar_searchBtn__DxOjQ"};